/* ============================================================
   JCB Global Distribution Hero — scroll-driven dotted globe
   Reads config + country markers from the section DOM.
   Depends on: window.JCB_GLOBE_LAND  (jcb-globe-land.js)
               window.JCB_GLOBE_COUNTRIES (jcb-globe-countries.js)
   ============================================================ */
(function () {
  'use strict';

  function initGlobe(section) {
    var cvs = section.querySelector('.gdh__globe');
    var stage = section.querySelector('.gdh__stage');
    if (!cvs || !stage) return;

    var cfgEl = section.querySelector('[data-gdh-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ctx = cvs.getContext('2d');
    var LAND = window.JCB_GLOBE_LAND || [];
    var CC = window.JCB_GLOBE_COUNTRIES || {};        // ISO2 -> [lat,lon]
    var NAMES = window.JCB_GLOBE_COUNTRY_NAMES || {};  // lower-name/alias -> ISO2

    // Resolve a token (2-letter code OR country name/alias) -> [lat,lon]
    function resolveToken(tok) {
      if (tok == null) return null;
      var s = String(tok).trim(); if (!s) return null;
      if (CC[s.toUpperCase()]) return CC[s.toUpperCase()];
      var code = NAMES[s.toLowerCase()];
      return code ? CC[code] : null;
    }

    // Hub (single) + marker list (from the "Marker countries" text field)
    var markers = [];
    var hub = null;
    var hc = resolveToken(cfg.hub);
    if (hc) { hub = { lat: hc[0], lon: hc[1], hub: true }; markers.push(hub); }
    (cfg.markers || []).forEach(function (tok) {
      var c = resolveToken(tok); if (!c) return;
      if (hub && c[0] === hub.lat && c[1] === hub.lon) return; // avoid duplicating the hub
      markers.push({ lat: c[0], lon: c[1], hub: false });
    });

    var color = cfg.color || '#FCB026';
    var rgb = hexToRgb(color);
    var TURN = (cfg.turns != null ? cfg.turns : 1.55) * 360;   // total rotation over full section
    var TILT = (cfg.tilt != null ? cfg.tilt : 0.5);
    var showArcs = cfg.arcs !== false;
    var pulse = cfg.pulse !== false && !reduce;
    var ROT0 = hub ? -hub.lon : 0;

    var W, H, DPR, cx, cy, R;
    function resize() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = stage.clientWidth; H = stage.clientHeight;
      cvs.style.width = W + 'px'; cvs.style.height = H + 'px';
      cvs.width = W * DPR; cvs.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      R = Math.min(W, H) * (W < 760 ? 0.34 : 0.40);
      cx = W * (W < 760 ? 0.5 : 0.66);
      cy = H * (W < 760 ? 0.40 : 0.5);
    }
    window.addEventListener('resize', resize);
    resize();

    function vec(lat, lon, rot) {
      var la = lat * Math.PI / 180, lo = (lon + rot) * Math.PI / 180;
      return { x: Math.cos(la) * Math.sin(lo), y: Math.sin(la), z: Math.cos(la) * Math.cos(lo) };
    }
    function project(v) {
      var y2 = v.y * Math.cos(TILT) - v.z * Math.sin(TILT);
      var z2 = v.y * Math.sin(TILT) + v.z * Math.cos(TILT);
      return { sx: cx + v.x * R, sy: cy - y2 * R, z: z2 };
    }

    function drawArc(a, b, rot, t) {
      var va = vec(a.lat, a.lon, rot), vb = vec(b.lat, b.lon, rot);
      var dot = va.x * vb.x + va.y * vb.y + va.z * vb.z; dot = Math.max(-1, Math.min(1, dot));
      var theta = Math.acos(dot), st = Math.sin(theta); if (st < 1e-4) return;
      var seg = 26, pts = [];
      for (var s = 0; s <= seg; s++) {
        var f = s / seg, w1 = Math.sin((1 - f) * theta) / st, w2 = Math.sin(f * theta) / st;
        var x = va.x * w1 + vb.x * w2, y = va.y * w1 + vb.y * w2, z = va.z * w1 + vb.z * w2;
        var m = Math.sqrt(x * x + y * y + z * z); x /= m; y /= m; z /= m;
        var lift = 1 + 0.16 * Math.sin(f * Math.PI);
        pts.push(project({ x: x * lift, y: y * lift, z: z * lift }));
      }
      ctx.beginPath(); var started = false;
      for (var p = 0; p < pts.length; p++) {
        if (pts[p].z > 0) { if (!started) { ctx.moveTo(pts[p].sx, pts[p].sy); started = true; } else ctx.lineTo(pts[p].sx, pts[p].sy); }
        else started = false;
      }
      ctx.strokeStyle = 'rgba(' + rgb + ',.45)'; ctx.lineWidth = 1.1; ctx.stroke();
      if (pulse) {
        var idx = Math.floor((t % 1) * seg), pp = pts[idx];
        if (pp && pp.z > 0) {
          var pu = 0.5 + 0.5 * Math.sin(t * 9);
          ctx.save();
          ctx.shadowColor = 'rgba(' + rgb + ',.9)'; ctx.shadowBlur = 5 + 8 * pu;
          ctx.beginPath(); ctx.arc(pp.sx, pp.sy, 1.4 + 2.0 * pu, 0, 7);
          ctx.fillStyle = 'rgba(255,255,255,' + (0.4 + 0.6 * pu).toFixed(3) + ')'; ctx.fill();
          ctx.restore();
        }
      }
    }

    function draw(rot, t) {
      ctx.clearRect(0, 0, W, H);
      var g = ctx.createRadialGradient(cx, cy, R * 0.2, cx, cy, R * 1.08);
      g.addColorStop(0, 'rgba(' + rgb + ',.06)'); g.addColorStop(1, 'rgba(' + rgb + ',0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(cx, cy, R * 1.08, 0, 7); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 7);
      ctx.strokeStyle = 'rgba(' + rgb + ',.16)'; ctx.lineWidth = 1; ctx.stroke();

      for (var d = 0; d < LAND.length; d++) {
        var pd = project(vec(LAND[d][0], LAND[d][1], rot));
        if (pd.z <= 0) continue;
        var a = 0.16 + 0.5 * pd.z;
        ctx.beginPath(); ctx.arc(pd.sx, pd.sy, 0.5 + 0.72 * pd.z, 0, 7);
        ctx.fillStyle = 'rgba(' + rgb + ',' + a.toFixed(3) + ')'; ctx.fill();
      }

      if (showArcs && hub) {
        for (var c = 0; c < markers.length; c++) {
          if (markers[c] === hub) continue;
          drawArc(hub, markers[c], rot, t + c * 0.13);
        }
      }

      for (var mi = 0; mi < markers.length; mi++) {
        var pm = project(vec(markers[mi].lat, markers[mi].lon, rot)); if (pm.z <= 0) continue;
        var isHub = markers[mi].hub;
        var pl = pulse ? (0.5 + 0.5 * Math.sin(t * 6.28 + mi)) : 0;
        ctx.beginPath(); ctx.arc(pm.sx, pm.sy, 3.0 + (isHub ? 1.5 : 0) + pl * 2.0, 0, 7);
        ctx.fillStyle = 'rgba(' + rgb + ',' + (0.35 + 0.4 * pm.z) + ')'; ctx.fill();
        ctx.beginPath(); ctx.arc(pm.sx, pm.sy, 2.0 + (isHub ? 1 : 0), 0, 7);
        ctx.fillStyle = isHub ? '#fff' : color; ctx.fill();
      }
    }

    // ---- scroll → progress ----
    var chapters = Array.prototype.slice.call(section.querySelectorAll('.gdh__chapter'));
    var prog = section.querySelector('.gdh__progress');
    var hint = section.querySelector('.gdh__hint');
    var progress = 0, rotProgress = 0, counted = false;

    function compute() {
      var rectTop = section.getBoundingClientRect().top;
      var total = section.offsetHeight - window.innerHeight;
      progress = clamp(-rectTop / (total || 1));
      rotProgress = clamp(-rectTop / (section.offsetHeight || 1));
      if (prog) prog.style.width = (progress * 100) + '%';
      if (hint) hint.style.opacity = progress > 0.02 ? 0 : 1;
      var n = chapters.length || 1;
      var active = Math.min(n - 1, Math.floor(progress * n));
      chapters.forEach(function (ch, i) { ch.classList.toggle('is-active', i === active); });
      if (chapters[active] && chapters[active].hasAttribute('data-has-stats')) runCounters(chapters[active]);
    }
    window.addEventListener('scroll', compute, { passive: true });

    function runCounters(chapter) {
      if (counted) return; counted = true;
      chapter.querySelectorAll('[data-count]').forEach(function (el) {
        var raw = (el.getAttribute('data-count') || '').trim();
        var target = parseFloat(raw.replace(/,/g, '')) || 0;
        var suffix = raw.replace(/^[\d.,\s]+/, ''); // trailing non-numeric, e.g. "+"
        var start = null, dur = 1100;
        if (reduce) { el.textContent = target + suffix; return; }
        function step(ts) {
          if (!start) start = ts; var k = Math.min(1, (ts - start) / dur);
          el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))) + suffix;
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }

    var idle = 0;
    function frame(ts) {
      var t = ts / 1000;
      if (!reduce) idle += 0.0016;
      var rot = ROT0 + rotProgress * TURN + idle * 12;
      draw(rot, t);
      requestAnimationFrame(frame);
    }
    compute();
    requestAnimationFrame(frame);
  }

  function clamp(v) { return Math.max(0, Math.min(1, v)); }
  function hexToRgb(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
    return m ? parseInt(m[1], 16) + ',' + parseInt(m[2], 16) + ',' + parseInt(m[3], 16) : '252,176,38';
  }

  function boot() {
    document.querySelectorAll('[data-gdh]').forEach(initGlobe);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init when added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-gdh]') || (e.target.matches && e.target.matches('[data-gdh]') ? e.target : null);
    if (s) initGlobe(s);
  });
})();
